<template>
  <v-col
    cols="0"
    lg="3"
    class=""
  >
    <v-navigation-drawer
      id="app-drawer"
      v-model="inputValue"
      clipped
      :class="{'v-navigation-drawer--fixed': $vuetify.breakpoint.mdAndDown}"
    />
  </v-col>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'
export default {
  name: 'Sidebar',
  data: () => ({
    drawer: null
  }),
  computed: {
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    }
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer'])
  }
}
</script>
